import React from 'react';
import { Stack, Box, Divider, Chip } from '@mui/material';

const ImageStack = ({ imagen, descrip, titulo }) => {
  return (
    <Stack direction="column" spacing={2} alignItems="center">
      <Divider sx={{ width: '100%' }} className='divi-info'>
        <Chip label={titulo} size="small" color='secondary' sx={{ border: 1 }} />
      </Divider>
      <Box
        component="img"
        src={imagen}
        alt={descrip}
        sx={{
          width: '100%', // Ajustar al ancho deseado
          height: 'auto', // Mantener la proporción
          maxWidth: 350, // Limitar el ancho máximo
          marginBottom: '16px !important'
        }}
      />
    </Stack>
  );
};

export default ImageStack;